<form [formGroup]="addGiftCardForm" class="add-wallet-form-container" (ngSubmit)="onAddGiftCardFormSubmit()">
    <div class="header-wrapper">
        <span class="form-title">{{'modals.add_wallet_modal.add_a_gift_card' | transloco}}</span>
        <button class="button-undecorated" type="button" style="border-radius: 100%;" [attr.aria-label]="'Close Order Details Modal'"
            (click)="closeModal($event)">
            <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" />
        </button>
    </div>

        @if(allErrors?.length){
            <div class="errors-container">
                <div class="generic-errors">
                    @for (error of allErrors; track $index) {
                    <div class="error-wrapper">
                        <div class="icon-wrapper">
                            <cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>
                        </div>
                        <span class="error">{{error}}.</span>
                    </div>
                    }
                </div>
            </div>
        }

    <div class="input-group">
        <div class="input-wrapper">
            <cwo-input formControlName="friendlyName" [type]="'text'" [placeholder]="'Friendly Name'" [required]="true"
                [invalid]="showErrors && addGiftCardForm.controls['friendlyName'].invalid" />
            <div class="errors-wrapper">
                @if(showErrors && addGiftCardForm.controls['friendlyName'].invalid &&
                addGiftCardForm.controls['friendlyName'].hasError('required')){
                <span class="input-error">
                    <cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>
                    {{validationMessages.friendlyName.required}}
                </span>
                }
            </div>
        </div>
        <div class="card-number-pin-group">
            <div class="input-wrapper card-number-input">
                <cwo-mask-field-input formControlName="number" [label]="'Gift Card Number'"
                    [maskPattern]="maskFieldInputType.giftCard"
                    [invalid]="showErrors && addGiftCardForm.controls['number'].invalid" />
                <div class="errors-wrapper">
                    @if(showErrors && addGiftCardForm.controls['number'].invalid &&
                    addGiftCardForm.controls['number'].hasError('required')){
                    <span class="input-error">
                        <cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>
                        {{validationMessages.giftCardNumber.required}}
                    </span>
                    }
                </div>
            </div>
            <div class="input-wrapper pin-input">
                <cwo-input formControlName="pin" [type]="'number'" [placeholder]="'PIN'" [required]="true"
                    [invalid]="showErrors && addGiftCardForm.controls['pin'].invalid" />
                <div class="errors-wrapper">
                    @if(showErrors && addGiftCardForm.controls['pin'].invalid &&
                    addGiftCardForm.controls['pin'].hasError('required')){
                    <span class="input-error">
                        <cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>
                        {{validationMessages.pin.required}}
                    </span>
                    }
                </div>
            </div>
        </div>
    </div>

    <div class="button-container">
        <button type="submit" class="button-accent submit-button">
            {{'modals.add_wallet_modal.done' | transloco}}
        </button>
    </div>
</form>